export const environment = {
  production: false,
  baseURL: 'https://test3-api.ymunity.com.br/api',
  sessionKey: 'ymunity_frontend_backoffice-session-dev',
  themeKey: 'ymunity_frontend_backoffice-theme-dev',
};
